import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TableComponent } from '@huge-monorepo/shared/components';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NavigationTabComponent } from '@huge-monorepo/shared/components';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MonthDatePickerComponent } from '@huge-monorepo/shared/components';
import { PipesModule } from './pipes/pipes.module';
import { MultiNavCategorySelectComponent } from './multi-nav-category-select/multi-nav-category-select.component';
import { DirectivesModule } from '../modules/directives/directives.module';
import { YesNoModalComponent } from './yes-no-modal/yes-no-modal.component';

@NgModule({
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  declarations: [
    TableComponent,
    NavigationTabComponent,
    MonthDatePickerComponent,
    MultiNavCategorySelectComponent,
    YesNoModalComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    NgxMatSelectSearchModule,
    NgxMaterialTimepickerModule,
    DragDropModule,
    PipesModule,
    DirectivesModule,
    NgApexchartsModule,
  ],
  exports: [
    TableComponent,
    NavigationTabComponent,
    MonthDatePickerComponent,
    MultiNavCategorySelectComponent,
    DirectivesModule,
    YesNoModalComponent,
  ],
})
export class ToolsModule { }
